module.exports = __webpack_public_path__ + "img/h5_banner01.3af85790.webp";